const projectColumns = () => [
  {
    dataField: "id",
    text: "#",
    sort: true,
  },
  {
    dataField: "name",
    text: "Projects",
    sort: true,
  },
  {
    dataField: "start_date",
    text: "Start Date",
    sort: true,
  },
  {
    dataField: "end_date",
    text: "End Date",
    sort: true,
  },
  {
    dataField: "budget",
    text: "Budget",
    sort: true,
  },
]

export default projectColumns
